import React, { Component } from "react";
import { Modal, Button, Row, Col, Card } from "react-bootstrap";
import parseHtml from "html-react-parser";

class QuestionsModal extends Component {
  // Parse HTML
  parseFun(html) {
    if (!html && html !== 0) return "";
    return parseHtml(String(html));
  }

  // Question Number
  idFunction(index) {
    return `Q${index + 1}`;
  }

  // LIST 1
  isValidJSON(question) {
    try {
      let qText = question.question
        .replaceAll('src="', "src='")
        .replaceAll('" alt=""', "' alt=''")
        .replaceAll('" ', "' ")
        .replaceAll('="', "='")
        .replace(/<\/p>\s*<p>/g, "</p><p>");

      let parsed = JSON.parse(qText);

      return (
        <ol
          className="ml-3 p-0"
          type={
            question.list1type === "alphabets"
              ? "A"
              : question.list1type === "numbers"
              ? "1"
              : "I"
          }
        >
          {parsed.map((item, idx) => (
            <li key={idx}>{this.parseFun(item.qlist1)}</li>
          ))}
        </ol>
      );
    } catch {
      return false;
    }
  }

  // LIST 2
  isValidJSON2(question) {
    try {
      let qText = question.question
        .replaceAll('src="', "src='")
        .replaceAll('" alt=""', "' alt=''")
        .replaceAll('" ', "' ")
        .replaceAll('="', "='")
        .replace(/<\/p>\s*<p>/g, "</p><p>");

      let parsed = JSON.parse(qText);

      return (
        <ol
          className="ml-3 p-0"
          type={
            question.list2type === "alphabets"
              ? "A"
              : question.list2type === "numbers"
              ? "1"
              : "I"
          }
        >
          {parsed.map((item, idx) => (
            <li key={idx}>{this.parseFun(item.qlist2)}</li>
          ))}
        </ol>
      );
    } catch {
      return false;
    }
  }

  // OPTIONS (no checkbox)
  renderOptions(question) {
    const opts = [
      { key: "A", text: question.option1 },
      { key: "B", text: question.option2 },
      { key: "C", text: question.option3 },
      { key: "D", text: question.option4 }
    ];

    return (
      <div style={{ marginTop: 10 }}>
        {opts.map((opt, i) => (
          <div key={i} style={{ display: "flex", marginBottom: 4 }}>
            <strong style={{ marginRight: 6 }}>{opt.key})</strong>
            <div>{this.parseFun(opt.text)}</div>
          </div>
        ))}
      </div>
    );
  }

  // Render question card
  renderQuestionCard(question, index) {
    const qType = String(question.qtype);

    // Subject name
    const subjectLine = (
      <div
        style={{
          fontSize: "14px",
          fontWeight: "600",
          color: "#333",
          marginBottom: "6px"
        }}
      >
        Subject: {question.subject_name || "N/A"}
      </div>
    );

    // Header for normal questions
    const headerNormal = (
      <div style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
        <strong>{this.idFunction(index)}</strong>
        <div>{this.parseFun(question.question)}</div>
      </div>
    );

    // Header for LIST type questions
    const headerList = (
      <div style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
        <strong>{this.idFunction(index)}</strong>
        <div><strong>Match the following</strong></div>
      </div>
    );

    return (
      <div
        style={{
          border: "1px solid #ddd",
          borderRadius: "6px",
          padding: "15px",
          background: "#fafafa",
          marginBottom: "12px"
        }}
      >
        {/* SUBJECT */}
        {subjectLine}

        {/* MATCH TYPE */}
        {["3", "9"].includes(qType) ? (
          <>
            {headerList}

            <Row>
              <Col xl={6}>
                <h6>List I</h6>
                {this.isValidJSON(question)}
              </Col>

              <Col xl={6}>
                <h6>List II</h6>
                {this.isValidJSON2(question)}
              </Col>
            </Row>

            {this.renderOptions(question)}
          </>
        ) : qType === "8" ? (
          <>
            {headerNormal}
            <i style={{ color: "#777" }}>(Numerical Answer Question)</i>
          </>
        ) : qType === "5" ? (
          <>
            {question.compquestion && (
              <Card className="p-2 mb-2">
                {this.parseFun(question.compquestion)}
              </Card>
            )}
            {headerNormal}
            {this.renderOptions(question)}
          </>
        ) : (
          <>
            {headerNormal}
            {this.renderOptions(question)}
          </>
        )}
      </div>
    );
  }

  // MAIN RENDER
  render() {
    const questions = this.props.getPracticeQuestions || [];

    return (
      <Modal centered size="lg" {...this.props}>
        {/* HEADER FIXED */}
        <div
          style={{
            background: "#28a745",
            padding: "12px 20px",
            color: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: 18,
            fontWeight: "bold",
            position: "sticky",
            top: 0,
            zIndex: 10
          }}
        >
          Questions
          <Button
            variant="link"
            className="text-white p-0"
            style={{ fontSize: 22 }}
            onClick={this.props.onHide}
          >
            ×
          </Button>
        </div>

        {/* SCROLLABLE BODY */}
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto", paddingTop: 10 }}>
          {questions.length === 0 ? (
            <div>No questions found.</div>
          ) : (
            questions.map((q, i) => (
              <div key={i}>{this.renderQuestionCard(q, i)}</div>
            ))
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

export default QuestionsModal;
